(function () {
  'use strict';
  const NB = window.NB = window.NB || {};

  function init(root) {
    root = root?.matches?.('[data-section-type="configurator"]')
      ? root : document.getElementById('configurator');
    if (!root || root.__mergedConfigurator) return;
    root.__mergedConfigurator = true;

    const C = NB.config;
    const U = NB.util;
    const q = selector => root.querySelector(selector);
    const abort = new AbortController();
    const on = (target, event, handler) =>
      target.addEventListener(event, handler, { signal: abort.signal });
    const el = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    const form = q('#configurator-form');
    const fields = q('[data-name-fields]');
    const error = q('#configurator-error');
    const compact = q('[data-edit-preview]');
    const mobile = matchMedia('(max-width: 760px)');
    const mainBracelet = NB.createProductPreview(q('[data-config-preview], [data-necklace-preview]'));
    const compactBracelet = NB.createProductPreview(
      q('[data-compact-preview]'), { shine: false, shadow: false }
    );
    /* Presets (e.g. men.html or index.html?preset=him) only shape the
     * initial, unedited state. Unknown/invalid presets or values fall back
     * to the normal defaults. Names are never taken from the URL. */
    function resolvePreset() {
      let key = null;
      try {
        key = new URLSearchParams(location.search).get('preset');
      } catch { key = null; }
      if (!key) key = document.body?.dataset.nbPreset || null;
      const presets = C.presets || {};
      return key && Object.prototype.hasOwnProperty.call(presets, key)
        ? key : null;
    }
    function presetState(key) {
      const base = {
        count: C.defaults.count,
        names: C.defaults.names.slice(),
        color: C.defaults.color,
        font: C.defaults.font
      };
      const preset = key ? C.presets[key] : null;
      if (!preset) return base;
      if (Number.isInteger(preset.count)
          && preset.count >= 1 && preset.count <= C.maxNames) {
        base.count = preset.count;
      }
      if (preset.color
          && Object.prototype.hasOwnProperty.call(C.colors, preset.color)) {
        base.color = preset.color;
      }
      const font = preset.font
        && C.fonts.find(item => item.id === preset.font);
      if (font && font.latin !== false) base.font = font.id;
      return base;
    }
    const activePreset = resolvePreset();
    const product = NB.productKind({template_suffix: root.dataset.previewType, handle: root.dataset.productHandle, type: root.dataset.productType});
    const nameFieldCount = product === 'bracelet' ? C.maxNames : product === 'pair' ? 2 : 1;
    const pairPreview = product === 'pair' ? NB.createProductPreview(q('[data-pair-item="1"]')) : null;
    const commerce = NB.shopify.setup(root);
    const state = Object.assign(presetState(activePreset), commerce.initialState);
    // v7.17: drop retired font IDs (old 01-44) and non-purchasable fonts.
    if (!C.fonts.some(f => f.id === state.font && U.fontSelectable(f))) state.font = C.defaults.font;
    if (product === 'necklace') state.count = 1;
    if (product === 'pair') state.count = 2;
    // v7.16: bracelet selections support one through four names.
    if (!(state.count >= 1 && state.count <= C.maxNames)) {
      state.count = Math.min(Math.max(Number(state.count) || 1, 1), C.maxNames);
    }
    const query = new URLSearchParams(location.search);
    if (Object.prototype.hasOwnProperty.call(C.colors, query.get('color'))) state.color = query.get('color');
    const editId = null;
    let edited = false;
    let lastNameIndex = 0;
    // v7.17: 英字 / 日本語 tabs; first 6 rows of a tab show by default.
    let filter = U.fontById(state.font).lang === 'ja' ? 'ja' : 'en';
    const FONT_ROWS = 6;
    const jaLoaded = new Set();
    // Japanese fonts are fetched on demand, subset to the sample text only.
    function loadJaFont(font, text) {
      const key = font.family + '|' + text;
      if (jaLoaded.has(key)) return;
      jaLoaded.add(key);
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family='
        + encodeURIComponent(font.family).replace(/%20/g, '+')
        + '&text=' + encodeURIComponent(text) + '&display=swap';
      document.head.append(link);
    }

    // v7.19 jp-input: Latin or hiragana/katakana names (no kanji, no mixing).
    const NAME_PATTERN = '[A-Za-z]{1,10}|[\u3041-\u3096\u30A1-\u30FA\u30FC]{1,10}';
    const KANA_SET = Array.from({length: 0x3096 - 0x3041 + 1}, (_, i) => String.fromCharCode(0x3041 + i)).join('')
      + Array.from({length: 0x30FA - 0x30A1 + 1}, (_, i) => String.fromCharCode(0x30A1 + i)).join('') + 'ー';
    const isEn = () => /^en/i.test(document.documentElement.lang || '');
    const JA_DEFAULT_FONT = 'F33';
    function loadJaGlyphs(font) {
      if (font && font.lang === 'ja') loadJaFont(font, KANA_SET);
    }
    // Typing kana moves to a Japanese font; Latin-only names move back.
    function syncFontToScript() {
      const names = state.names.slice(0, state.count).filter(Boolean);
      if (!names.length) return;
      const font = U.fontById(state.font);
      const kana = names.some(U.isKanaName);
      const latinOnly = names.every(U.validName);
      if (kana && font.lang !== 'ja') {
        state.font = JA_DEFAULT_FONT;
        filter = 'ja';
        syncFilterTabs();
      } else if (latinOnly && font.lang === 'ja') {
        state.font = C.defaults.font;
        filter = 'en';
        syncFilterTabs();
      }
      loadJaGlyphs(U.fontById(state.font));
    }
    function syncFilterTabs() {
      root.querySelectorAll('[data-font-filter]').forEach(tab => {
        tab.setAttribute('aria-pressed', String(tab.dataset.fontFilter === filter));
      });
    }
    function fontMismatch() {
      const names = state.names.slice(0, state.count).filter(n => U.validAnyName(n));
      return names.length > 0 && !U.fontFits(U.fontById(state.font), names);
    }

    let fontRequest = 0;
    let editing = false;
    let editingPointer = null;
    let editingReleaseTimer = 0;
    let focusRequest = 0;
    let suppressed = [];

    function rawState() {
      return {
        product,
        names: state.names.slice(0, state.count),
        count: state.count,
        color: state.color,
        font: state.font
      };
    }

    function showError(message) {
      error.textContent = message || '';
      error.hidden = !message;
    }

    function emitEdit() {
      edited = true;
      NB.approval.invalidate();
      showError('');
      render();
      document.dispatchEvent(new CustomEvent('nb:config-change', {
        detail: rawState()
      }));
    }

    function radio(container, group, value, title, subtitle, checked) {
      const label = el('label', 'merged-choice');
      const input = el('input');
      input.type = 'radio';
      input.name = group;
      input.value = value;
      input.checked = checked;
      const body = el('span', 'merged-choice__body');
      body.append(el('span', '', title));
      if (subtitle) body.append(el('small', '', subtitle));
      label.append(input, body);
      container.append(label);
      return { input, body };
    }

    function buildCounts() {
      const container = q('[data-count-options]');
      if (product !== 'bracelet') return;
      for (let count = 1; count <= (product === 'necklace' ? 1 : C.maxNames); count++) {
        const { input } = radio(
          container, 'properties[名前の数]', String(count),
          count === 1 ? window.CariamText("product.one_name", '1名') : window.CariamText("copy.text_257", "[v0]名", {v0: count}),
          '', count === state.count
        );
        input.dataset.count = String(count);
        on(input, 'change', () => {
          state.count = Number(input.value);
          for (let index = 0; index < nameFieldCount; index++) {
            fields.children[index].hidden = index >= state.count;
            fields.children[index].querySelector('input').disabled =
              index >= state.count;
          }
          updateCountHint();
          emitEdit();
        });
      }
      const hint = el('p', 'merged-count-hint');
      hint.dataset.countHint = '';
      hint.setAttribute('aria-live', 'polite');
      const scenes = el('p', 'merged-count-scenes', window.CariamText("copy.count_scenes", 'お子さまの名前、ご夫婦の名前、ペットの名前を入れて。母の日の贈りものにも。'));
      scenes.dataset.countScenes = '';
      container.after(hint, scenes);
      updateCountHint();
    }

    function updateCountHint() {
      const hint = root.querySelector('[data-count-hint]');
      if (hint) hint.textContent = window.CariamText(`copy.count_hint_${state.count}`, '');
    }

    function buildNames() {
      for (let index = 0; index < nameFieldCount; index++) {
        const row = el('div', 'merged-name-row');
        row.hidden = index >= state.count;
        const label = el('label', '', product === 'pair' ? window.CariamText("copy.text_258", "ブレスレット[v0]の名前", {v0: index + 1}) : window.CariamText("copy.text_259", "名前 [v0]", {v0: index + 1}));
        label.htmlFor = `name-${index + 1}`;
        const input = el('input');
        input.id = label.htmlFor;
        input.name = product === 'pair' ? `properties[ブレスレット${index + 1}・名前]` : `properties[名前${index + 1}]`;
        input.pattern = NAME_PATTERN;
        input.type = 'text';
        input.dataset.nameInput = String(index);
        input.value = state.names[index] || '';
        input.maxLength = C.name.maxChars;
        input.placeholder = ['Haru', 'Yui', 'Sora', 'Mio'][index] || '';
        input.required = true;
        input.disabled = index >= state.count;
        input.autocomplete = 'off';
        input.autocapitalize = 'off';
        input.spellcheck = false;
        input.setAttribute('autocorrect', 'off');
        input.setAttribute('aria-describedby',
          `name-instructions name-note-${index + 1}`);
        const note = el('p', 'merged-name-note');
        note.id = `name-note-${index + 1}`;
        note.setAttribute('aria-live', 'polite');
        row.append(label, input, note);
        fields.append(row);

        // Do not sanitize or normalize: invalid characters stay visible and
        // prevent confirmation rather than silently changing someone's name.
        on(input, 'input', () => {
          state.names[index] = input.value;
          // Wait for IME composition to finish before switching fonts.
          if (!input.dataset.composing) syncFontToScript();
          emitEdit();
        });
        on(input, 'compositionstart', () => { input.dataset.composing = '1'; });
        on(input, 'compositionend', () => {
          delete input.dataset.composing;
          state.names[index] = input.value;
          syncFontToScript();
          emitEdit();
        });
        on(input, 'focus', () => {
          lastNameIndex = index;
          if (product === 'pair') {
            q('[data-compact-preview]').dataset.pairItem = String(index);
            compact.querySelector('span').textContent = window.CariamText("copy.text_260", "ブレスレット[v0]の名前・大文字小文字は入力どおり", {v0: index + 1});
            compactBracelet.render(rawState());
          }
          setEditing(true);
          keepInputVisible(input);
        });
        on(input, 'blur', () => {
          queueMicrotask(() => {
            setEditing(Boolean(
              root.contains(document.activeElement)
              && document.activeElement.matches('[data-name-input]')
            ));
          });
        });
      }
    }

    // Rebuild a colour chip label with <wbr> only at natural word breaks
    // (CSS keep-all forbids any other break), so 'ー' is never orphaned.
    function chipLabel(body, parts) {
      const label = body.querySelector('span');
      if (!label || !parts || parts.join('') !== label.textContent) return;
      label.className = 'merged-color-label';
      label.textContent = '';
      parts.forEach((part, i) => {
        if (i) label.append(document.createElement('wbr'));
        label.append(part);
      });
    }

    function buildColors() {
      const container = q('[data-color-options]');
      Object.entries(C.colors).forEach(([key, color]) => {
        const { input, body } = radio(
          container, 'properties[カラー]', key, color.label, '',
          state.color === key
        );
        input.value = color.orderLabel;
        input.dataset.color = key;
        chipLabel(body, color.labelParts);
        const swatch = el('span', 'merged-color-swatch');
        swatch.style.backgroundImage = color.swatch;
        swatch.setAttribute('aria-hidden', 'true');
        body.prepend(swatch);
        on(input, 'change', () => {
          state.color = key;
          emitEdit();
        });
      });
    }

    function buildFonts() {
      const filters = q('[data-font-filters]');
      const tabs = el('div', 'font-lang-tabs');
      tabs.setAttribute('role', 'group');
      tabs.setAttribute('aria-label', window.CariamText("font_tab.label", '書体の種類'));
      C.fontCategories.forEach(category => {
        const button = el('button', 'font-lang-tab', category.label);
        button.type = 'button';
        button.dataset.fontFilter = category.key;
        button.setAttribute('aria-pressed', String(category.key === filter));
        tabs.append(button);
        on(button, 'click', () => {
          if (filter === category.key) return;
          filter = category.key;
          tabs.querySelectorAll('button').forEach(node => {
            node.setAttribute('aria-pressed', String(node.dataset.fontFilter === filter));
          });
          q('[data-font-grid]').classList.add('premium-fonts-collapsed');
          const toggle = root.querySelector('[data-premium-fonts]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          renderFontTiles();
        });
      });
      filters.after(tabs);

      const grid = q('[data-font-grid]');
      C.fonts.forEach(font => {
        const selectable = U.fontSelectable(font);
        const button = el('button', 'merged-font-tile');
        button.type = 'button';
        button.dataset.font = font.id;
        button.dataset.lang = font.lang;
        if (!selectable) button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-pressed', String(font.id === state.font));
        button.setAttribute('aria-label', `${font.label}${selectable ? '' : window.CariamText("font_note.contact", '・お問い合わせで承ります')}`);
        const number = el('span', 'merged-font-number', `${font.label}`);
        if (font.upperDisplay || font.upper) {
          const note = el('small', 'merged-font-note', window.CariamText("font_note.upper", '大文字で入ります'));
          note.dataset.fontNote = 'upper';
          number.append(note);
        }
        const sample = el('span', 'merged-font-sample');
        sample.lang = font.lang;
        Object.assign(sample.style, NB.fonts.css(font));
        button.append(number, sample);
        grid.append(button);
        on(button, 'click', () => {
          if (!selectable || state.font === font.id) return;
          state.font = font.id;
          loadJaGlyphs(font);
          emitEdit();
        });
      });
    }

    function renderFontTiles() {
      const enName = rawState().names.find(Boolean) || 'Momo';
      const jaName = 'もも';
      let index = 0;
      q('[data-font-grid]').querySelectorAll('[data-font]').forEach(tile => {
        const font = U.fontById(tile.dataset.font);
        const inTab = font.lang === filter;
        tile.hidden = !inTab;
        tile.classList.toggle('is-extra', inTab && index++ >= FONT_ROWS);
        tile.setAttribute('aria-pressed', String(font.id === state.font));
        const text = font.lang === 'ja' ? jaName : enName;
        tile.querySelector('.merged-font-sample').textContent = text;
        if (font.lang === 'ja' && inTab) loadJaFont(font, text);
      });
      const toggle = root.querySelector('[data-premium-fonts]');
      if (toggle) {
        toggle.dataset.more = window.CariamText("premium_fonts_more_n", "ほかの書体も見る（全[v0]種）", {v0: index});
        toggle.hidden = index <= FONT_ROWS;
        toggle.textContent = toggle.getAttribute('aria-expanded') === 'true' ? toggle.dataset.less : toggle.dataset.more;
      }
    }

    function nameFeedback() {
      fields.querySelectorAll('[data-name-input]').forEach((input, index) => {
        if (index >= state.count) return;
        const name = state.names[index];
        const font = U.fontById(state.font);
        const blocked = U.excludedChars(name);
        const valid = U.validAnyName(name);
        const capitalConflict = valid && font.upper
          && name !== name.toUpperCase();
        input.setAttribute('aria-invalid',
          String(blocked.length > 0 || !valid || capitalConflict));
        const note = fields.children[index].querySelector('.merged-name-note');
        const warning = U.caseWarning(name);
        note.dataset.invalid = String(blocked.length > 0 || !valid || capitalConflict || (valid && fontMismatch()));
        note.dataset.unavailable = String(blocked.length > 0);
        note.textContent = blocked.length
          ? window.CariamText("copy.kana_unavailable", "この文字は現在お選びいただけません。（[v0]）", {v0: blocked.join('・')})
          : !valid && /[^\x00-\x7F]/.test(name || '')
          ? (isEn()
            ? 'Use 1–10 Latin letters, or 1–10 hiragana/katakana. Kanji and mixed scripts are not available.'
            : 'ひらがな・カタカナ、または半角英字で1〜10文字で入力してください。漢字・混在は使えません。')
          : !valid
          ? window.CariamText("copy.text_247", '半角英字1〜10文字で入力してください。空白・数字・記号は使えません。')
          : fontMismatch()
          ? (isEn()
            ? 'Choose a Japanese font for hiragana/katakana names, or an English font for Latin names.'
            : 'ひらがな・カタカナの名前は日本語書体、英字の名前は英字書体をお選びください。')
          : capitalConflict
            ? window.CariamText("copy.text_267", "[v0] は大文字専用です。大文字で入力するか、別の書体を選んでください。", {v0: font.label})
            : warning
              ? window.CariamText("copy.text_268", "[v0]・入力どおりに表示されます。", {v0: warning})
              : window.CariamText("copy.text_269", '大文字・小文字は入力どおりです。');
      });
      syncUnavailable();
    }

    // v7.18 fix4: block add-to-cart while an unavailable kana is in a name.
    function hasUnavailable() {
      return Array.from(fields.querySelectorAll('[data-name-input]'))
        .some((input, index) => index < state.count && U.excludedChars(input.value).length > 0);
    }
    function syncUnavailable() {
      const blocked = hasUnavailable() || fontMismatch();
      form.querySelectorAll('[type="submit"]').forEach(btn => {
        if (!('npBaseDisabled' in btn.dataset)) btn.dataset.npBaseDisabled = String(btn.disabled);
        btn.disabled = blocked || btn.dataset.npBaseDisabled === 'true';
        btn.toggleAttribute('data-unavailable-kana', blocked);
      });
    }

    // v7.13: bracelet product photos show the 2-name image for 2 names.
    function renderPhotos(design) {
      root.querySelectorAll('img[data-photo-one][data-photo-two]').forEach(img => {
        const src = design.count === 2 ? img.dataset.photoTwo : img.dataset.photoOne;
        if (src && img.getAttribute('src') !== src) img.setAttribute('src', src);
      });
      root.querySelectorAll('[data-photo-note]').forEach(note => { note.hidden = design.count !== 2; });
    }

    function render() {
      const design = rawState();
      renderPhotos(design);
      mainBracelet.render(design);
      compactBracelet.render(design);
      pairPreview?.render(design);
      commerce.sync(design);
      q('[data-font-summary]').textContent =
        window.CariamText("copy.text_270", "選択中：[v0]（参考書体）", {v0: U.fontById(state.font).label});
      renderFontTiles();
      nameFeedback();

      const request = ++fontRequest;
      q('[data-font-status]').textContent = window.CariamText("copy.text_271", '書体を読み込んでいます…');
      NB.fonts.ensure(U.fontById(state.font)).then(ok => {
        if (request !== fontRequest || abort.signal.aborted) return;
        q('[data-font-status]').textContent = ok
          ? window.CariamText("copy.text_272", '書体を読み込みました。プレビューは参考表示です。')
          : window.CariamText("copy.text_273", '書体を読み込めません。接続を確認してから綴り確認に進んでください。');
      });
    }

    // Suppress existing fixed/sticky UI while editing, including legacy theme
    // bars. Ancestors are made static rather than hidden, preserving the form.
    // Original inline styles/priorities are restored exactly on exit.
    function suppressOtherSticky() {
      suppressed = [];
      document.querySelectorAll('body *').forEach(node => {
        if (!(node instanceof HTMLElement)
            || node === compact || compact.contains(node)
            || node.closest('dialog')
            || !node.getClientRects().length) return;
        const position = getComputedStyle(node).position;
        if (position !== 'fixed' && position !== 'sticky') return;
        const ancestor = node.contains(compact);
        const property = ancestor ? 'position' : 'visibility';
        suppressed.push({
          node, property,
          value: node.style.getPropertyValue(property),
          priority: node.style.getPropertyPriority(property)
        });
        node.style.setProperty(
          property, ancestor ? 'static' : 'hidden', 'important'
        );
      });
    }

    function restoreSticky() {
      suppressed.forEach(({ node, property, value, priority }) => {
        if (value) node.style.setProperty(property, value, priority);
        else node.style.removeProperty(property);
      });
      suppressed = [];
    }

    function setEditing(wanted) {
      const next = wanted && mobile.matches;
      // Blur runs between pointerdown and click. Collapsing the in-flow
      // preview here would move the control away from the user's finger.
      if (!next && mobile.matches && editingPointer !== null) return;
      if (editing === next) return;
      editing = next;
      if (next) {
        suppressOtherSticky();
        document.body.classList.add('nb-name-editing');
        compact.hidden = false;
      } else {
        compact.hidden = true;
        document.body.classList.remove('nb-name-editing');
        restoreSticky();
      }
    }

    function keepInputVisible(input) {
      const request = ++focusRequest;
      requestAnimationFrame(() => {
        // Pinch zoom also resizes/pans the visual viewport. Leave its position
        // to the gesture; only normal-scale keyboard changes may re-centre input.
        if (request !== focusRequest || !editing
            || document.activeElement !== input
            || Math.abs((window.visualViewport?.scale || 1) - 1) > 0.01) return;
        const rect = input.getBoundingClientRect();
        const viewport = window.visualViewport;
        const top = viewport?.offsetTop || 0;
        const bottom = top + (viewport?.height || window.innerHeight);
        if (rect.top < top + 122 || rect.bottom > bottom - 20) {
          input.scrollIntoView({
            block: 'center', behavior: 'auto'
          });
        }
      });
    }

    function refreshEditing() {
      const input = document.activeElement;
      const active = root.contains(input)
        && input.matches('[data-name-input]');
      setEditing(active);
      if (active) keepInputVisible(input);
    }

    on(window, 'pointerdown', event => {
      if (!editing) return;
      clearTimeout(editingReleaseTimer);
      editingPointer = event.pointerId;
    });
    const releaseEditingPointer = event => {
      if (event.pointerId !== editingPointer) return;
      // Run after mouseup/click and the label's native radio activation.
      // Also releases after a cancelled gesture or a drag with no click.
      editingReleaseTimer = setTimeout(() => {
        editingPointer = null;
        refreshEditing();
      }, 0);
    };
    on(window, 'pointerup', releaseEditingPointer);
    on(window, 'pointercancel', releaseEditingPointer);

    on(form, 'submit', event => {
      event.preventDefault();
      if (hasUnavailable()) {
        syncUnavailable();
        fields.querySelector('[aria-invalid="true"]')?.focus();
        return;
      }
      try {
        const candidate = U.snapshot(rawState());
        showError('');
        if (!NB.confirm?.open) {
          throw new Error(window.CariamText("copy.text_274", '綴り確認の準備ができていません。もう一度お試しください。'));
        }
        setEditing(false);
        NB.confirm.open(candidate, NB.approval.revision());
      } catch (failure) {
        showError(failure.message);
        error.focus();
      }
    });

    on(document, 'nb:edit-names', () => {
      const input = fields.querySelector('input:not(:disabled)');
      input?.focus({ preventScroll: true });
      if (input) {
        refreshEditing();
        input.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    });
    on(mobile, 'change', refreshEditing);
    if (window.visualViewport) {
      on(window.visualViewport, 'resize', refreshEditing);
    }

    // A section reload can reuse this DOM after destroy() aborts its listeners.
    // Replace generated controls so every input belongs to this renderer.
    root.querySelectorAll('[data-count-options], [data-name-fields], [data-color-options], [data-font-filters], [data-font-grid]')
      .forEach(container => container.replaceChildren());
    buildCounts();
    buildNames();
    buildColors();
    buildFonts();
    root.querySelectorAll('[data-sample-name]').forEach(button => on(button, 'click', () => {
      const index = lastNameIndex < state.count ? lastNameIndex : 0;
      state.names[index] = button.dataset.sampleName;
      fields.children[index].querySelector('input').value = state.names[index];
      emitEdit();
    }));
    render();


    // Re-sync every control with state (used by applyPreset only).
    function syncControls() {
      root.querySelectorAll('input[data-count]').forEach(input => {
        input.checked = Number(input.value) === state.count;
      });
      root.querySelectorAll('input[data-color]').forEach(input => {
        input.checked = input.dataset.color === state.color;
      });
      for (let index = 0; index < nameFieldCount; index++) {
        const row = fields.children[index];
        row.hidden = index >= state.count;
        const input = row.querySelector('input');
        input.disabled = index >= state.count;
        input.value = state.names[index] || '';
      }
      NB.approval.invalidate();
      render();
    }

    const api = {
      getState: rawState,
      editId,
      preset: activePreset,
      isEdited: () => edited,
      /* Applies a preset only while nothing has been edited. Returns
       * whether it was applied; never overwrites customer input. */
      applyPreset(key) {
        if (edited || !key
            || !Object.prototype.hasOwnProperty.call(C.presets || {}, key)) {
          return false;
        }
        Object.assign(state, presetState(key));
        if (product === 'necklace') state.count = 1;
        if (product === 'pair') state.count = 2;
        syncControls();
        return true;
      },
      validate: () => U.snapshot(rawState()),
      refresh: render,
      destroy() {
        clearTimeout(editingReleaseTimer);
        editingPointer = null;
        setEditing(false);
        abort.abort();
        fontRequest++;
        mainBracelet.destroy();
        pairPreview?.destroy();
        compactBracelet.destroy();
        root.__mergedConfigurator = null;
        if (NB.configurator === api) delete NB.configurator;
      }
    };
    root.__mergedConfigurator = api;
    NB.configurator = api;

    on(document, 'shopify:section:unload', event => {
      if (event.target === root || event.target.contains?.(root)) api.destroy();
    });
  }

  NB.registerSection('configurator', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', event => {
    const root = event.target.matches?.('[data-section-type="configurator"]')
      ? event.target
      : event.target.querySelector?.('[data-section-type="configurator"]');
    if (root) init(root);
  });
})();
